import { CategoryViewAll } from '@/app/elements/category-view-all';

import './styles/@theme';

type ZoneHeaderProps = {
    title?: string;
    subtitle?: string;
    categoryUid?: string;
};

export const ZoneHeader = ({ title, subtitle, categoryUid }: ZoneHeaderProps) => {
    return (
        title && (
            <div data-testid="zone-header" className="zone__header">
                <div className="zone__header__title">
                    <h2>{title}</h2>
                    {categoryUid && <CategoryViewAll categoryUid={categoryUid} zoneName={title} />}
                    {/* TODO: subtitle for jackpots zone */}
                </div>
                {subtitle && <p data-testid="zone-header-subtitle">{subtitle}</p>}
            </div>
        )
    );
};
